export const url = {
  findList: '/auth/home/findList',
  applyForWebAuthority: '/auth/user/applyForWebAuthority',
  getWebBanner: '/auth/banner/findList',
  checkCollection: '/auth/collection/checkCollection',
  addCollection: '/auth/collection/save',
  removeCollection: '/auth/collection/remove'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/homePage.js